// extracted by mini-css-extract-plugin
export default {"answer":"notice_answer__I9p9g","container":"notice_container__gAk+V","note":"notice_note__R8icN","noteFade":"notice_noteFade__nSR74","fadeOut":"notice_fadeOut__2zVrj"};